import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { PROPERTY_OWNERSHIP_V2_API } from "../apiRoutes";

interface mutateProps {
  id: string;
  data: FieldValues;
  communityId: string;
}
const mutateUpdatePropertyOwner = async ({
  id,
  communityId,
  data,
}: mutateProps) => {
  return await axiosAuth.patch(`${PROPERTY_OWNERSHIP_V2_API(communityId)}/${id}`, data);
};

const useUpdatePropertyOwnerV2Mutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdatePropertyOwner,
    ...queryParams,
  });

export default useUpdatePropertyOwnerV2Mutation;
